import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SizeDescription,
  SizesSectionContainer,
  SizesTitle,
  InfoWrapper
} from './styled';

interface SizesSectionProps {
  rooms?: number | null;
  area: string;
  floor?: number | null;
  floors?: number | null;
  landArea: string;
  categoryName?: string;
  buildingTypeName?: string | null;
}

export const SizesSection: React.FC<SizesSectionProps> = ({
  rooms,
  area,
  floor,
  floors,
  landArea,
  categoryName,
  buildingTypeName
}) => {
  const { t } = useTranslation();

  const getSizesList = () => {
    const paramsList = [];

    if (categoryName && rooms) {
      paramsList.push({
        value: `${t('cards.item_card.rooms', { count: rooms })}`,
        description: categoryName
      });
    }

    if (area) {
      paramsList.push({
        value: area,
        description: t('pages.current_item.area')
      });
    }

    if (floor) {
      paramsList.push({
        value: `${floor} / ${floors}`,
        description: t('cards.item_card.floor')
      });
    } else if (landArea) {
      paramsList.push({
        value: landArea,
        description: t('pages.current_item.land_area')
      });
    }

    if (buildingTypeName) {
      paramsList.push({
        value: buildingTypeName,
        description: t('pages.current_item.building_type')
      });
    }

    return paramsList;
  };
  const sizes = getSizesList();

  return (
    <SizesSectionContainer
      data-cy="sizes-section"
      $withSpaceBetween={sizes.length > 2}
    >
      {sizes.map((item, i) => (
        <InfoWrapper key={i}>
          <SizesTitle tag="h2" data-cy="sizes-section__val">
            {item.value}
          </SizesTitle>
          <SizeDescription tag="body_2" data-cy="sizes-section__desc">
            {item.description}
          </SizeDescription>
        </InfoWrapper>
      ))}
    </SizesSectionContainer>
  );
};
